/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {StreamBankLink} from "../../../../Common/StreamBankLink";
import {usePermission} from "../../../../../Hooks/PermissionHooks";

export function SpeciesListNameTableColumn(props) {
    const {Value, rowData, HasPermission} = props;
    const hasPermission = usePermission();

    if (hasPermission('can_view_species_list')) {
        return <StreamBankLink
            className="sb-actionable-link"
            Href={"/speciesLists/" + rowData?.speciesListId}
        >
            {Value}
        </StreamBankLink>;
    } else {
        return <span>{Value}</span>;
    }
}


